import { Button, Chip, Dialog, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { StyledTableRow } from "helpers/CustomMenu";
import DeleteDialog from "helpers/DeleteDialog";
import FormDialog from "helpers/FormDialog";
import moment from "moment";
import React, { useEffect, useState } from "react";

const ActingResources = ({ onSuccess,open, setOpen, FetchDetails, myActing, actingOnBehalf, setViewActing, viewActing, hasPendingRequest }) => {
    const [count, setCount] = useState(0);
    const [value, setValue] = React.useState({});
    const [id, setId] = React.useState();
    const [resourcesList, setResourcesList] = useState([]);

    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const statusList = [{ label: 'Approved', value: 'approved' }, { label: 'Busy', value: 'busy' }]
    const setValue0 = (name, val) => {
        if (!name) {
            return null;
        }

        setValue(v => {
            v[name] = val;
            return { ...v };
        });
    }

    const getAllResources = async () => {
        const resp = await FetchDetails(`/api/request/list/resources`);
        if (resp.status) {
            setResourcesList(resp?.data?.data?.map(v => ({ label: v.names, value: v.id })));

        }
    }
    useEffect(() => {
        getAllResources().then()
    }, []);
    return <>
        <DeleteDialog url={`/api/request/delete/acting/${id}`} open={deleteOpen} setOpen={setDeleteOpen} onSuccess={() => setCount(v => v + 1)} title={'Delete Record'} />
        <FormDialog maxWidth='md' onSuccess={() =>{ setOpen(0);onSuccess()}} url={open === 1 ? '/api/request/add-acting/' : `/api/request/update/acting/${id}`} fields={[

            {
                name: "status",
                type: "select",
                label: "Status",
                value: value['status'],
                values: statusList,
                required: open === 3,
                setValue: (val) => setValue0('status', val),
                hidden: open !== 3
            },
            {
                name: "acting",
                type: "select",
                label: "Acting",
                value: value['acting'],
                values: resourcesList,
                required: open === 1,
                setValue: (val) => setValue0('acting', val),
                hidden: open === 3
            },
            {
                name: "startDate",
                label: "Start",
                value: value['startDate'],
                required: open === 1,
                type: 'date',
                setValue: (val) => setValue0('startDate', val),
                hidden: open === 3
            },
            {
                name: "endDate",
                label: "End",
                value: value['endDate'],
                required: open === 1,
                type: 'date',
                setValue: (val) => setValue0('endDate', val),
                hidden: open === 3
            },
            {
                name: "reason",
                label: "Reason",
                type: "textarea",
                required: open === 1,
                value: value['reason'],
                setValue: (val) => setValue0('reason', val),
                hidden: open === 3

            },
            {
                name: "handover",
                label: "Handover",
                type: "editor",
                value: value['handover'],
                required: open === 1,
                setValue: (val) => setValue0('handover', val),
                hidden: open === 3

            },
        ]} open={open} setOpen={setOpen} title={open === 1 ? 'Acting Request' : open === 3 ? 'Approve or Deny' : 'Edit'} />

        <Dialog open={viewActing?.open} onClose={() => setViewActing({ open: false })} maxWidth={'md'}>
            <DialogTitle>{viewActing?.outgoing ? 'Outgoing Request' : 'Incoming Request'}</DialogTitle>
            <DialogContent>
                {viewActing?.outgoing &&
                    <TableContainer >
                        <Table sx={{ minWidth: 700 }}>
                            <TableHead>
                                <TableCell >#</TableCell>
                                <TableCell >Acting</TableCell>
                                {/* <TableCell >On Behalf Of</TableCell> */}
                                <TableCell >Start Date</TableCell>
                                <TableCell >End Date</TableCell>
                                <TableCell >Status</TableCell>
                            </TableHead>
                            <TableBody>
                                {myActing?.length > 0 ?
                                    myActing?.map((row, i) => (
                                        <StyledTableRow sx={{
                                            cursor: "pointer"
                                        }}
                                        // onClick={() => history.push(`/admin/project/details/${row.id}`)} key={row.id} hover={true}
                                        >
                                            <TableCell >{i + 1}</TableCell>
                                            <TableCell >{row?.actor?.names}</TableCell>
                                            {/* <TableCell >{row?.behalfOf?.names}</TableCell> */}
                                            <TableCell >{moment(row?.startDate).format("YYYY-MM-DD")}</TableCell>
                                            <TableCell >{moment(row?.endDate).format("YYYY-MM-DD")}</TableCell>
                                            <TableCell ><Chip size={'small'} label={row?.status} /></TableCell>

                                        </StyledTableRow>
                                    )) : <TableRow >
                                        <TableCell
                                            colSpan={5} className={"text-center"} style={{ textAlign: "center" }}><span className={"text-center"}>{"No Request found"}</span></TableCell>
                                    </TableRow>}
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
                {viewActing?.incoming &&

                    <TableContainer >
                        <Table sx={{ minWidth: 700 }}>
                            <TableHead>
                                <TableCell >#</TableCell>
                                {/* <TableCell >Acting</TableCell> */}
                                <TableCell >Acting On Behalf Of</TableCell>
                                <TableCell >Start Date</TableCell>
                                <TableCell >End Date</TableCell>
                                <TableCell >Status</TableCell>
                                {hasPendingRequest.length>0 ? <TableCell >Action</TableCell> : null}
                            </TableHead>
                            <TableBody>
                                {actingOnBehalf?.length > 0 ?
                                    actingOnBehalf?.map((row, i) => (
                                        <StyledTableRow sx={{
                                            cursor: "pointer"
                                        }}
                                        // onClick={() => history.push(`/admin/project/details/${row.id}`)} key={row.id} hover={true}
                                        >
                                            <TableCell >{i + 1}</TableCell>
                                            {/* <TableCell >{row?.actor?.names}</TableCell> */}
                                            <TableCell >{row?.behalfOf?.names}</TableCell>
                                            <TableCell >{moment(row?.startDate).format("YYYY-MM-DD")}</TableCell>
                                            <TableCell >{moment(row?.endDate).format("YYYY-MM-DD")}</TableCell>
                                            <TableCell ><Chip size={'small'} label={row?.status} /></TableCell>
                                            {hasPendingRequest.length>0 && row?.status === 'pending' ? <TableCell >
                                                <Button variant="contained" size="small" onClick={() => { setOpen(3); setId(row.id) }}>Approve/Deny</Button>
                                            </TableCell> : null}
                                        </StyledTableRow>
                                    )) : <TableRow >
                                        <TableCell
                                            colSpan={5} className={"text-center"} style={{ textAlign: "center" }}><span className={"text-center"}>{"No Request found"}</span></TableCell>
                                    </TableRow>}
                            </TableBody>
                        </Table>
                    </TableContainer>}
            </DialogContent>
            {/* <DialogActions>
                {loading0 ? <CircularProgress /> : <Button variant={'contained'} onClick={newTechnologySubmit}>
                    Submit
                </Button>}
            </DialogActions> */}
        </Dialog>

    </>
}

export default ActingResources
